import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/ru'
import { MazPhoneNumberInput } from 'maz-ui'
import VModal from 'vue-js-modal'
import VueQriously from 'vue-qriously'

import App from './App'
import router from './router'

Vue.use(VModal)
Vue.use(VueQriously)

Vue.use(VueMoment, { moment })
Vue.use(VueLocalStorage)
Vue.use(MazPhoneNumberInput)

const addPadding = (string) => String(string).length > 1 ? string : '0' + string

Vue.filter('declOfNum', function (number, ...titles) {
  const cases = [2, 0, 1, 1, 1, 2]
  return number + ' ' + titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
})

Vue.filter('costFormat', function (value) {
  if (!value && value !== 0) return ''
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
})

Vue.filter('hourFormat', function (hour) {
  let hourString = hour.toString()
  if (hourString.length < 2) hourString = '0' + hourString
  return hourString + ':00'
})

Vue.filter('dateFormat', function (isoString, hour) {
  return `${addPadding(new Date(isoString).getDate())}.${addPadding(new Date(isoString).getMonth() + 1)}.${new Date(isoString).getFullYear()} в ${addPadding(hour)}:00`
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  localStorage: {
    order: {
      type: Object
    }
  },
  render: h => h(App),
  template: '<App/>',
  components: { App }
})

if (!Array.prototype.find) {
  /* eslint-disable no-extend-native */
  Array.prototype.find = function (predicate) {
    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined')
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function')
    }
    var list = Object(this)
    var length = list.length >>> 0
    var thisArg = arguments[1]
    var value

    for (var i = 0; i < length; i++) {
      value = list[i]
      if (predicate.call(thisArg, value, i, list)) {
        return value
      }
    }
    return undefined
  }
}
